import { useSearchParams } from 'react-router';
import CorrectiveActionsAssignedToMe from '../../views/CorrectiveActionsAssignedToMe';
import { useApiClients } from '../../client/api/useApiClient';
import { useQuery } from '@tanstack/react-query';
import {
  CorrectiveActionControllerGetAllCorrectiveActionAssignedToMeAttentionNeededEnum,
  CorrectiveActionControllerGetAllCorrectiveActionAssignedToMePriorityEnum,
  CorrectiveActionControllerGetAllCorrectiveActionAssignedToMeStatusEnum,
  GetCorrectiveActionAssignedToMeResponse,
} from '@EHSNavigator/backend';

export default function CorrectiveActionsAssignedToMePage() {
  const { CorrectiveActionApi } = useApiClients();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('search') ?? '';
  const currentPage = searchParams.get('page') ?? 1;
  const status = searchParams.get('status') ?? null;
  const attentionNeeded = searchParams.get('attentionNeeded') ?? null;
  const priority = searchParams.get('priority') ?? null;
  const dueDays = searchParams.get('dueDays') ?? null;
  const limit = Number(searchParams.get('limit')) || 10;

  const query: any = {
    page: Number(currentPage),
  };
  if (searchQuery) query.search = searchQuery;
  if (dueDays) query.dueDays = dueDays;
  if (status) query.status = status;
  if (attentionNeeded) query.attentionNeeded = attentionNeeded;
  if (priority) query.priority = priority;
  if (limit) query.limit = Number(limit);

  const {
    data: allCorrectiveActionAssignedToMe,
    isLoading,
    isRefetching,
  } = useQuery<GetCorrectiveActionAssignedToMeResponse, Error, any>({
    queryKey: [
      'all-corrective-action-assigned-to-me',
      Number(currentPage),
      searchQuery,
      Number(dueDays),
      priority,
      status,
      attentionNeeded,
      Number(limit),
    ],
    queryFn: async () => {
      const response =
        await CorrectiveActionApi.correctiveActionControllerGetAllCorrectiveActionAssignedToMe(
          {
            search: searchQuery,
            page: Number(currentPage) || 1,
            attentionNeeded:
              attentionNeeded as CorrectiveActionControllerGetAllCorrectiveActionAssignedToMeAttentionNeededEnum,
            limit: Number(limit),
            dueInDays: Number(dueDays),
            priority:
              priority as CorrectiveActionControllerGetAllCorrectiveActionAssignedToMePriorityEnum,
            status:
              status as CorrectiveActionControllerGetAllCorrectiveActionAssignedToMeStatusEnum,
          },
        );

      return response?.data;
    },
  });

  const hasFilters =
    !!searchQuery || !!status || !!priority || !!dueDays || !!attentionNeeded;

  const noDataMessage = hasFilters
    ? 'No items match your filters or search. Try using different keywords maybe.'
    : 'No corrective action assigned';

  return (
    <div className="flex w-full flex-1 flex-col px-15 pt-14 pb-10 md:px-25 lg:pr-14 lg:pb-20 lg:pl-8">
      <CorrectiveActionsAssignedToMe
        data={
          allCorrectiveActionAssignedToMe as GetCorrectiveActionAssignedToMeResponse
        }
        params={{
          search: searchQuery,
          page: Number(currentPage),
          dueInDays: Number(dueDays),
          priority:
            priority as CorrectiveActionControllerGetAllCorrectiveActionAssignedToMePriorityEnum,
          status:
            status as CorrectiveActionControllerGetAllCorrectiveActionAssignedToMeStatusEnum,
          attentionNeeded:
            attentionNeeded as CorrectiveActionControllerGetAllCorrectiveActionAssignedToMeAttentionNeededEnum,
          limit: Number(limit),
        }}
        noDataMessage={noDataMessage}
        isIncidentsLoading={isLoading || isRefetching}
      />
    </div>
  );
}
